import React from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect, BrowserRouter } from "react-router-dom";
import './styles/App.scss';
import 'remixicon/fonts/remixicon.css'
import 'simplebar/dist/simplebar.min.css'
import './assets/libs/JUICY/styles/JUICY.scss';
import { BodyProvider } from './context/BodyContext.js'
import Routing from './Router/Routing'

function App() {
  return (
    <div className="APP">
      <Router>
        <BodyProvider>
          <BrowserRouter >
            <Switch>
              {/* Routes */}
              <Route path="/" component={Routing.guest} />
              <Route path="/dashboard" component={Routing.user} />
              <Route path="/admin" component={Routing.admin} />
              <Redirect path='*' to="/" />
            </Switch>
          </BrowserRouter>
        </BodyProvider>
      </Router>
    </div>
  );
}

export default App;
